import { ApprovalStatus } from './registration-status.enum'

export const ApprovalStatusActionMap = new Map()
  .set(ApprovalStatus.PENDING_REVIEW, [
    { status: ApprovalStatus.APPROVED, text: 'Approve', name: 'approve', hasPayment: false },
    { status: ApprovalStatus.PENDING_PAYMENT, text: 'Approve to pay', name: 'approve-to-pay', hasPayment: true },
    { status: ApprovalStatus.DECLINED, text: 'Decline', name: 'decline', paymentAgnostic: true },
    { status: ApprovalStatus.AWAITING_REVISION, text: 'Request revision', name: 'request-revision', paymentAgnostic: true }
  ])
  .set(ApprovalStatus.PENDING_PAYMENT, [
    { status: ApprovalStatus.APPROVED, text: 'Approve', name: 'approve', hasPayment: false, disabled: true },
    { status: ApprovalStatus.PENDING_PAYMENT, text: 'Approve to pay', name: 'approve-to-pay', hasPayment: true, disabled: true },
    { status: ApprovalStatus.DECLINED, text: 'Decline', name: 'decline', paymentAgnostic: true, disabled: true },
    { status: ApprovalStatus.AWAITING_REVISION, text: 'Request revision', name: 'request-revision', paymentAgnostic: true, disabled: true }
  ])
  .set(ApprovalStatus.AWAITING_REVISION, [
    { status: ApprovalStatus.APPROVED, text: 'Approve', name: 'approve', hasPayment: false },
    { status: ApprovalStatus.PENDING_PAYMENT, text: 'Approve to pay', name: 'approve-to-pay', hasPayment: true },
    { status: ApprovalStatus.DECLINED, text: 'Decline', name: 'decline', paymentAgnostic: true },
    { status: ApprovalStatus.AWAITING_REVISION, text: 'Request revision', name: 'request-revision', paymentAgnostic: true, disabled: true }
  ])
  .set(ApprovalStatus.UPDATED, [
    { status: ApprovalStatus.APPROVED, text: 'Approve', name: 'approve', hasPayment: false },
    { status: ApprovalStatus.PENDING_PAYMENT, text: 'Approve to pay', name: 'approve-to-pay', hasPayment: true },
    { status: ApprovalStatus.DECLINED, text: 'Decline', name: 'decline', paymentAgnostic: true },
    { status: ApprovalStatus.AWAITING_REVISION, text: 'Request revision', name: 'request-revision', paymentAgnostic: true }
  ])
  .set(ApprovalStatus.APPROVED, [
    { status: ApprovalStatus.APPROVED, text: 'Approve', name: 'approve', hasPayment: false, disabled: true },
    { status: ApprovalStatus.PENDING_PAYMENT, text: 'Approve to pay', name: 'approve-to-pay', hasPayment: true, disabled: true },
    { status: ApprovalStatus.DECLINED, text: 'Decline', name: 'decline', paymentAgnostic: true },
    { status: ApprovalStatus.AWAITING_REVISION, text: 'Request revision', name: 'request-revision', paymentAgnostic: true }
  ])
  .set(ApprovalStatus.DECLINED, [
    { status: ApprovalStatus.APPROVED, text: 'Approve', name: 'approve', hasPayment: false },
    { status: ApprovalStatus.PENDING_PAYMENT, text: 'Approve to pay', name: 'approve-to-pay', hasPayment: true },
    { status: ApprovalStatus.DECLINED, text: 'Decline', name: 'decline', paymentAgnostic: true, disabled: true },
    { status: ApprovalStatus.AWAITING_REVISION, text: 'Request revision', name: 'request-revision', paymentAgnostic: true }
  ])
